'use client';

import Link from 'next/link';

import {
  PricelistMenu,
// eslint-disable-next-line @stylistic/max-len
} from '@/app/(routes)/(misc)/pricelists/_components/page-content/pricelist-menu';
import { ContactItem } from '@/components/contact-item';
import { ImageWithFallback } from '@/components/image-with-fallback';
import { joinSgcmMedia, joinSgcmSite } from '@/utils/url/join/public';

import {
  SECTION_SUB_TITLE_PRICELIST,
  SECTION_TITLE_DISTRIBUTOR,
  VIEW_ALL_LINK_TEXT,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PriceHistory: Component = ({
  carDetailData,
  dealerDetailDataList,
}) => {
  const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en', { month: 'short' });
    return `${day} ${month}`;
  };

  const latestData = formatDate(dealerDetailDataList![0]
    .pricelistDates.slice().reverse()[0]);

  const handleItemClick = (data: string | number | undefined) => {
    window.open(joinSgcmSite(`new_cars/pricelist/${dealerDetailDataList![0].id}/${data}.pdf`), '_blank');
  };

  return (
    <main>
      <div className={styles.containerPriceHistory}>
        <div className={styles.containerDealerInfo}>
          <div className={styles.containerDistributor}>
            <div className={styles.textTitle}>
              {SECTION_TITLE_DISTRIBUTOR}
            </div>
            <div className={styles.containerDealerDetail}>
              {carDetailData.authorizeDealers?.map(
                dealer => (
                  <div
                    key={dealer.id}
                    className={styles.containerDealer}>
                    <Link
                      className={styles.textDealerName}
                      href={joinSgcmSite(`new_cars/newcars_listing.php?DID=${dealer.id}`)}>
                      {dealer.name}
                    </Link>
                    <div className={styles.containerInfo}>
                      <ContactItem
                        contactType="hotline"
                        displayMode="default"
                        list={dealer.hotlines}
                        separator="|" />
                      { dealer.whatsAppNumber
                        ? (
                          <ContactItem
                            contactType="whatsApp"
                            displayMode="default"
                            list={[dealer.whatsAppNumber]}
                            target="_blank" />
                        )
                        : null }
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
          <div className={styles.containerDistributor}>
            <div className={styles.textTitle}>
              {SECTION_SUB_TITLE_PRICELIST}
            </div>
            <div className={styles.containerPriceList}>
              <div className={styles.containerLatesDate}>
                <ImageWithFallback
                  alt=""
                  className={styles.imageDownload}
                  height={16}
                  src={`${joinSgcmMedia('/public/new-cars/icon/downloadIcon.svg')}`}
                  width={18} />
                <Link
                  className={styles.linkLatestDate}
                  href={joinSgcmSite(`new_cars/pricelist/${dealerDetailDataList![0].id}/${dealerDetailDataList![0].pricelistDates.slice(-1)[0]}.pdf`)}
                  target="_blank">
                  {latestData}
                </Link>
              </div>
              <div className={styles.containerAnotherDate}>
                <PricelistMenu
                  menuClassName={styles.containerMenu}
                  menuName="Another Date"
                  optionList={
                    dealerDetailDataList![0]
                      .pricelistDates.slice().reverse().map(price => ({
                        value: price,
                        text: price,
                      }))
                  }
                  pricelistType="pi"
                  onItemClick={data => handleItemClick(data)} />
              </div>
            </div>
          </div>
          <Link
            className={styles.viewAllLink}
            href={joinSgcmSite(`new_cars/newcars_car_model.php?Brand=${carDetailData.make}`)}>
            {VIEW_ALL_LINK_TEXT(carDetailData.make)}
          </Link>
        </div>
      </div>
    </main>
  );
};
